import { useElementSize } from "@resamare/react-hooks";

const CALENDAR_MAX_WIDTH = 500;

/**
 * Hook qui calcule le nombre de mois à afficher en fonction de la largeur du conteneur
 * @param inline - Si le calendrier est affiché en ligne
 * @returns Un objet contenant la référence du conteneur et le nombre de mois à afficher
 */
export function useMonthsShown(inline: boolean): {
    ref: (instance: HTMLDivElement | null) => void;
    monthsShownLength: number;
} {
    const [ref, { width }] = useElementSize<HTMLDivElement>();
    const monthsShownLength = inline ? Math.floor((width || 0) / CALENDAR_MAX_WIDTH) + 1 : 1;
    return { ref, monthsShownLength };
}
